import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CardWeekHeader, DayCard } from '.';
import { LessonsPlanLesson } from 'state/modules/entity/types';
import { formatUiDate } from 'util/date-util';
import { remCalc } from 'util/style-util';

type Props = {
  lessons: Array<LessonsPlanLesson>;
  classes: any;
  handleMoveCard: (currentIndex: number, dragIndex: number) => any;
  tourData: { [key: string]: boolean };
};

const maybeFormatDate = date => (date ? formatUiDate(new Date(date)) : '');

export const WeekCardList: any = ({ lessons, handleMoveCard, tourData }: Props) => {
  const classes = useStyles()();

  return lessons.map(
    ({ dayOfWeek, lessonDate, date, lessons, assignments, allowInstruction }, idx) => (
      <Grid
        item
        key={idx.toString()}
        id={`lessonCardGroup-${idx}`}
        style={{
          padding: '20px',
          position: 'relative',
          zIndex: tourData?.highlightDayCard && idx === 0 ? 1001 : 'inherit'
        }}
      >
        <CardWeekHeader
          day={dayOfWeek}
          date={maybeFormatDate(lessonDate || date)}
          className={classes.cardWeekTitle}
          key={idx.toString()}
        />

        <DayCard
          key={`${idx}-dayCard`}
          handleMoveCard={handleMoveCard}
          cardIndex={idx}
          className={classes.weekViewCard}
          lessonsOrAssignments={lessons || assignments}
          lessonDate={lessonDate}
          allowInstruction={allowInstruction}
        />
      </Grid>
    )
  );
};
const useStyles = () =>
  makeStyles(() => ({
    cardWeekTitle: {
      // display: 'flex',
      flex: 1,
      marginTop: '23px',
      marginBottom: '10px'
    },
    weekViewCard: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: remCalc(500),
      width: remCalc(240),
      paddingTop: '.5px'
    }
  }));
